import _service from './api';

const actions = {
  async isSieValid({ commit }, { studentSieId, studentBirthDate, token }) {
    const { data: response } = await _service.isSieValid(
      studentSieId,
      studentBirthDate,
      token
    );
    commit('setStudentWasValidated', response);
  },
  async getNotificationWays({ commit }, { studentSieId }) {
    const { data: response } = await _service.getNotificationWays(studentSieId);
    if (response) {
      commit('setNotificationWays', response);
    }
  },
  async getQuestionnaire({ commit }) {
    const { data: response } = await _service.getQuestionnaire();
    if (response) {
      commit('setQuestionnaire', response);
    }
  },
  async saveQuestionnaireAnswers(
    { commit },
    { studentSieId, notificationWayId, answers }
  ) {
    const { status, data: response } = await _service.saveQuestionnaireAnswers(
      studentSieId,
      notificationWayId,
      answers
    );
    if (status === 200) {
      if (response) {
        commit('setConfirmationNumber', response);
      }
    }
  },
};

export default actions;
